import "./UploadOption.css";
import { Image } from "react-bootstrap";
import { Typography } from "antd";
import UploadFile from "../FileUploadModal/FileUploadModal";
import FlowUploadModal from "../FlowUploadModal/FlowUploadModal";
import LinkUploadModal from "../LinkUploadModal/LinkUploadModal";
import { useTranslation } from "react-i18next";
import circle from "../../../assets/images/circle.png";
import { useActiveModal } from "../../../utilities/Models/modelUtils";
import { setActiveCard, setDashboardModalsOpens } from "../../../service/apiSlices/staticApi";
import { useDispatch, useSelector } from "react-redux";

const UploadOption = ({ option, ...restProps }: any) => {
  const { t } = useTranslation("common");
  const { activeModal, setActiveModal } = useActiveModal();
  const { activeCard } = useSelector((state: any) => state.static)
  const modalId = `${option.type}-modal`;
  const isOpen = activeCard === modalId;
  const dispatch = useDispatch();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setActiveModal(modalId);
    dispatch(setDashboardModalsOpens(true))
    dispatch(setActiveCard(modalId))
  };

  const handleModalClose = () => {
    setActiveModal(null);
    dispatch(setActiveCard(""))
    dispatch(setDashboardModalsOpens(false))
  };

  return (
    <div
      className={isOpen ? "card upload-option-card active" : "card upload-option-card"}
      onClick={handleClick}
      tabIndex={0}
    >
      <img src={circle} alt="circle" className="circle-animated-image" />
      <div className="card-header p-0 border-0 bg-tranparent active">
        <div className="card-icon">
          <Image src={option.icon} className="upload-card-icon" />
        </div>
      </div>
      <div className="card-body p-0">
        {option.type === "CSV" && (
          <UploadFile
            type={option.type}
            {...restProps}
            isModalOpen={isOpen}
            setIsModalOpen={handleModalClose}
          />
        )}
        {option.type === "FLOW_DIAGRAM" && (
          <FlowUploadModal
            type={option.type}
            isModalOpen={isOpen}
            setIsModalOpen={handleModalClose}
          />
        )}
        {option.type === "URL" && (
          <LinkUploadModal
            type={option.type}
            {...restProps}
            isModalOpen={isOpen}
            setIsModalOpen={handleModalClose}
          />
        )}
        {option.type === "semanticModel" && (
          <>
            <p className="card-link">
              {t('uploadOptions.semanticModel.title')}
            </p>
          </>
        )}
        <Typography.Paragraph
          ellipsis={{ rows: 3 }}
          title={option.description}
          className="mb-0 upload-card-description"
        >
          {option.description}
        </Typography.Paragraph>
      </div>
    </div>
  );
};

export default UploadOption;
